import { accountState } from "@/atoms/accountState";
import Search from "@/components/Guidebook/Search";
import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { colors, customEvent, NextLink } from "goi_common";
import { useRecoilValueLoadable } from "recoil";

import { GuidebookCarousel } from "./components/GuidebookCarousel";
import { GuidebookFooter } from "./components/GuidebookFooter";
import { GuidebookMainTabs } from "./components/GuidebookMainTabs";
import { ArticleSummary } from "pages/guidebook";

import MaxWidth1200Layout from "@/components/Layout/MaxWidth1200Layout";
import { FuneralPrepareBannerSection } from "../HomeContainer/components/RenewalVersion/FuneralPrepareBanner";

export default function GuidebookContainer({ articles }: { articles: ArticleSummary[] }) {
  const account = useRecoilValueLoadable(accountState);

  return (
    <MaxWidth1200Layout>
      <Box p="40px 24px 28px" className="head2_b">
        장례에 대한 모든 지식. <br />
        <span className="orange700">고이 가이드북</span>
      </Box>
      {/* <TopBanner path="guidebook" /> */}
      <SearchRoot>
        <NextLink
          href="/guidebook/search/"
          onClick={() => {
            customEvent({
              newGtm: {
                path: "guidebook",
                trigger_and_target: "search-uv_guidebook_search",
              },
            });
          }}
        >
          <Search
            type="primary"
            iconColor={colors.gray900}
            placeholder="궁금한 키워드를 검색하세요."
          />
        </NextLink>
      </SearchRoot>
      <FuneralPrepareBannerSection path="guidebook" />

      <GuidebookCarouselRoot>
        <Box className="subtitle3" padding="0px 24px">
          {account.contents?.nickname || "예비상주"}님에게 지금 필요한 정보
        </Box>
        <GuidebookCarousel />
      </GuidebookCarouselRoot>

      <GuidebookMainTabs articles={articles} />

      <GuidebookFooter />
    </MaxWidth1200Layout>
  );
}

const GuidebookCarouselRoot = styled.div`
  padding: 0 0 48px 0px;
`;
const SearchRoot = styled.div`
  padding: 36px 24px 40px;
`;
